import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star, Users, Award } from 'lucide-react';
export function TrustStrip() {
  const trustItems = [{
    icon: <MapPin className="w-6 h-6 text-white/70" data-id="element-200" />,
    text: '35+ Years in Miami Lakes'
  }, {
    icon: <Star className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-201" />,
    text: '4.9★ Patient Rating'
  }, {
    icon: <Users className="w-6 h-6 text-white/70" data-id="element-202" />,
    text: '2,000+ Happy Patients'
  }, {
    icon: <Award className="w-6 h-6 text-white/70" data-id="element-203" />,
    text: 'Invisalign Certified Provider'
  }];
  return <div className="bg-brand-darkAlt border-y border-white/10 py-5 lg:py-8" data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6 md:gap-4" data-id="element-206">
          {trustItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex flex-col items-center justify-center text-center space-y-2" data-id="element-207">
              <div className="bg-white/5 p-3 rounded-full" data-id="element-208">{item.icon}</div>
              <span className="font-medium text-white/80 text-sm md:text-base" data-id="element-209">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}